var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalWithTrigger", {
    attrs: { title: "Edit credit card" },
    scopedSlots: _vm._u([
      {
        key: "trigger",
        fn: function ({ openModal }) {
          return [
            _c("UiButton", {
              attrs: { buttonText: "Edit", variant: "secondary" },
              on: { click: openModal },
            }),
          ]
        },
      },
      {
        key: "default",
        fn: function ({ closeModal }) {
          return [
            _c("EditPaymentCardForm", {
              attrs: { currentUserId: _vm.currentUserId, cardId: _vm.cardId },
              on: {
                cardEdited: function ($event) {
                  return _vm.onCardEdited(closeModal)
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ disabled, processing, editCard }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "flex pt-3" },
                          [
                            _c("UiButton", {
                              staticClass: "mr-3",
                              attrs: {
                                buttonText: "Edit",
                                disabled: disabled,
                                processing: processing,
                              },
                              on: { click: editCard },
                            }),
                            _c("UiButton", {
                              attrs: {
                                buttonText: "Cancel",
                                variant: "outline",
                              },
                              on: { click: closeModal },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }